<template>
  <div>
    <Table
      :loading="tableLoading"
      class="mt24"
      :columns="columns"
      :data="tableData"
    ></Table>
  
    <Modal
      v-model="modalVisibile"
      width="400"
      :mask-closable="false"
      title="编辑"
      @on-cancel="handleCancel"
    >
      <Form
        @submit.native.prevent
        ref="modalForm"
        :model="modalForm"
        label-position="top"
      >
        <div class="clearfix mb32">
          <FormItem label="" class="fl">
            <Input v-model="modalForm.json_rule" class="input294Width"></Input>
          </FormItem>
        </div>
      </Form>
      <div slot="footer">
        <Button type="text" @click="handleCancel">取消</Button>
        <Button
          :loading="modalLoading"
          type="primary"
          @click="handleModalSubmit"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import mixins from "@/mixins/page";
export default {
  name: "user_manage",
  mixins: [mixins],
  data() {
    return {
      modalVisibile: false,
      modalLoading: false,
      tableData: [],
      modalForm: {
        json_rule: "",
      },
      modalForm1: {
        json_rule: "",
      },
      columns: [
        {
          title: "标题",
          key: "describe",
        },
        {
          title: "内容",
          key: "json_rule",
        },
        {
          title: "操作",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  class: {
                    btn_edit: true,
                  },
                  on: {
                    click: () => this.handleEdit(params),
                  },
                },
                "编辑"
              ),
            ]);
          },
        },
      ],
    };
  },
  mounted() {
    this.handleQuery();
  },
  methods: {
    handleModalSubmit() {
      this.modalLoading = true;

      this.$api.ruleEdit({ ...this.modalForm }).then((res) => {
        if (res.code === 0) {
          this.$Message.success(res.msg);
          this.modalVisibile = false;
          this.getTableData();
          this.handleCancel();
        } else {
          this.$Message.error(res.msg);
        }
        this.modalLoading = false;
      });
    },
    // 弹框取消
    handleCancel() {
      this.$refs.modalForm.resetFields();
      this.modalForm = Object.assign({}, this.modalForm1);
      this.modalVisibile = false;
    },
    handleEdit(params) {
      this.modalTitle = "编辑";
      this.modalVisibile = true;
      this.modalForm = Object.assign({}, params.row);
    },
    //日期范围
    handleDateChange(val) {
      if (val[0]) {
        this.formData.start_date = val[0] + " 00:00:00";
        this.formData.end_date = val[1] + " 23:59:59";
      } else {
        this.formData.start_date = "";
        this.formData.end_date = "";
      }
      this.handleQuery();
    },

    handleQuery() {
      this.page_num = 1;
      this.getTableData();
    },
    getTableData() {
      this.tableLoading = true;
      this.$api.ruleList({}).then((res) => {
        if (res.code === 0) {
          this.tableData = res.data;
        } else {
          this.$Message.error(res.msg);
        }
        this.tableLoading = false;
      });
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .table_pic {
  width: 35px;
  height: 35px;
  border-radius: 100%;
  display: block;
}
</style>
